import { z } from 'zod';
import i18n from '@/shared/i18n';

export const createWorkspaceSchema = z.object({
  workspaceName: z
    .string()
    .min(1, i18n.t('workspace.create.error.nameRequired', { ns: 'workspace' })),
  workspaceIcon: z.string(),
  workspaceColor: z.string(),
});

export type CreateWorkspaceFormData = z.infer<typeof createWorkspaceSchema>;
